module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.meetRequisites) ? _c('div', [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Verifique os motivos abaixo e tente novamente.")]), _vm._v(" "), _c('md-list', [_vm._l((_vm.messages), function(msg, index) {
    return _c('md-list-item', {
      key: index
    }, [_c('md-icon', [_vm._v("warning")]), _c('span', [_vm._v(_vm._s(msg))])], 1)
  }), _vm._v(" "), (_vm.notEmptyObject(_vm.navigator)) ? _c('md-list-item', [_c('md-icon', [_vm._v("web")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.navigator))])], 1) : _vm._e(), _vm._v(" "), (_vm.notEmptyObject(_vm.ram)) ? _c('md-list-item', [_c('md-icon', [_vm._v("memory")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ram))])], 1) : _vm._e(), _vm._v(" "), (_vm.notEmptyObject(_vm.storage)) ? _c('md-list-item', [_c('md-icon', [_vm._v("storage")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.storage))])], 1) : _vm._e()], 2), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Você pode continuar, porém as funcionalidades serão reduzidas e você precisará de internet para capturar as fotos.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.continueWithProcess
    }
  }, [_vm._v("Continuar com o Processo")])], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "md-title"
  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" seu aparelho não atende as especificações de utilização do aplicativo.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97c2eb38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckRequisites.vue
// module id = 841
// module chunks = 1